<template>
  <sh-modal
    label="Training Recommendation"
    id="training-modal"
    modal-height="fit-content"
    modal-width="1100px"
    @modal-closed="closeModalAndClean"
  >
    <div slot="header" style="display: flex; width: 100%">
      <div>
        <sh-text size="header-1">Training Recommendation</sh-text>
      </div>
    </div>

    <div
      style="display: flex; text-align: left; width: 100%; margin-bottom: 24px"
    >
      <div style="margin-right: 60px">
        <div>
          <sh-text style="text-align: left; font-weight: bold"
            >Review recommendation:
          </sh-text>
          <sh-radio-group style="margin-top: 6px" horizontal="true">
            <sh-radio-button
              label="Accept/Edit"
              :active="action == 'approve'"
              @active-changed="setAcceptRejRec({ e: $event, val: 'approve' })"
            ></sh-radio-button>
            <sh-radio-button
              label="Reject"
              :active="action == 'downgrade'"
              @active-changed="setAcceptRejRec({ e: $event, val: 'downgrade' })"
            ></sh-radio-button>
          </sh-radio-group>
        </div>
      </div>
      <div style="">
        <sh-text style="text-align: left; font-weight: bold"
          >Status: {{ getReviewDescription(status) }}
        </sh-text>
        <sh-text style="text-align: left; font-weight: bold"
          >Context: {{ context }}
        </sh-text>
        <sh-text style="text-align: left; margin-top: 12px"
          >Description: {{ description }}
        </sh-text>
        <!-- <sh-text style="text-align: left; margin-top: 12px"
          >Summary: {{ summary }}
        </sh-text> -->
      </div>
    </div>
    <sh-table condensed="true">
      <sh-table-row slot="header">
        <sh-table-head unsortable="true" columns="6"></sh-table-head>
        <sh-table-head unsortable="true" columns="9" style="padding-left: 140px"
          >Current KPIs</sh-table-head
        >
        <sh-table-head unsortable="true" columns="9" style="padding-left: 50px"
          >Expected KPIs in 3 months (after trained)</sh-table-head
        >
      </sh-table-row>
      <sh-table-row>
        <sh-table-cell columns="6"></sh-table-cell>
        <sh-table-cell columns="3" style="text-align: center"
          ><strong style="line-height: 1.2"
            >Utilization<br />
            (6 months)</strong
          ></sh-table-cell
        >
        <sh-table-cell columns="3" style="text-align: center"
          ><strong style="line-height: 1.2">Workload</strong></sh-table-cell
        >
        <sh-table-cell columns="3" style="text-align: center"
          ><strong style="line-height: 1.2"
            >Assignment counts</strong
          ></sh-table-cell
        >
        <sh-table-cell columns="3" style="text-align: center"
          ><strong style="line-height: 1.2"
            >Utilization<br />
            (6 months)</strong
          ></sh-table-cell
        >
        <sh-table-cell columns="3" style="text-align: center"
          ><strong style="line-height: 1.2">Workload</strong></sh-table-cell
        >
        <sh-table-cell columns="3" style="text-align: center"
          ><strong style="line-height: 1.2"
            >Assignment counts</strong
          ></sh-table-cell
        >
      </sh-table-row>
      <sh-table-row
        v-for="(cs, index) in recommended_training?.impacted_cses ?? []"
        :key="index"
      >
        <sh-table-cell columns="6">
          <div>{{ getCSEName(cs.cse_id) }}</div>
        </sh-table-cell>
        <sh-table-cell style="text-align: center" columns="3">
          <div>{{ cs.metrics.current_utilization }}</div>
        </sh-table-cell>
        <sh-table-cell style="text-align: center" columns="3">
          <div>{{ cs.metrics.current_workload }}</div>
        </sh-table-cell>
        <sh-table-cell style="text-align: center" columns="3">
          <div>{{ cs.metrics.current_primary_counts }}</div>
        </sh-table-cell>
        <sh-table-cell style="text-align: center" columns="3">
          <div>{{ cs.metrics.expected_utilization }}</div>
        </sh-table-cell>
        <sh-table-cell style="text-align: center" columns="3">
          <div>{{ cs.metrics.expected_workload }}</div>
        </sh-table-cell>
        <sh-table-cell style="text-align: center" columns="3">
          <div>{{ cs.metrics.expected_primary_counts }}</div>
        </sh-table-cell>
      </sh-table-row>
    </sh-table>
    <!-- <div v-if="'cse_id' in recommended_training">
      <sh-text style="text-align: left; font-weight: bold"
        >Impacted CSEs: {{ getCSEName(recommended_training.cse_id) }}</sh-text
      >
    </div>
    <div v-if="'impacted_cses' in recommended_training">
      <sh-text style="text-align: left"> Changes in assignments:</sh-text>
      <sh-text
        style="text-align: left"
        v-for="(cs, index) in recommended_training.impacted_cses"
        :key="index"
      >
        {{ getCSEName(cs.cse_id) }}</sh-text
      >
    </div> -->
    <div>
      <div v-if="'cse_id' in recommended_training">
        <sh-text
          style="
            text-align: left;
            font-weight: bold;
            display: inline;
            white-space: nowrap;
          "
        >
          Impacted CSEs: {{ getCSEName(recommended_training.cse_id) }}
        </sh-text>
      </div>
      <div v-if="'impacted_cses' in recommended_training">
        <sh-text style="text-align: left; display: inline; white-space: nowrap">
          Changes in assignments:
        </sh-text>
        <sh-text
          style="text-align: left; display: inline; white-space: nowrap"
          v-for="(cs, index) in recommended_training.impacted_cses"
          :key="index"
        >
          {{ getCSEName(cs.cse_id) }}
          <span v-if="index < recommended_training.impacted_cses.length - 1">
            |
          </span>
        </sh-text>
      </div>
    </div>

    <!-- Impacted CSEs: John Doe. Changes in assignments Jonathan Doe | John Hue |
        Johny Hue -->
    <div>
      <sh-text style="text-align: left; font-weight: bold"
        >Recommendation rating:</sh-text
      >
      <star-rating
        v-model:rating="rating"
        :read-only="status !== 'Review'"
        :star-size="25"
        :show-rating="false"
        @rating-selected="setRating($event)"
      >
      </star-rating>
      <sh-input-text
        style="margin-top: 24px; margin-bottom: 24px"
        :value="feedback"
        @value-changed="setRecComment($event)"
        textarea
        label="Add more details here. Your feedback would help improve subsequent recommendations."
      ></sh-input-text>
    </div>
  </sh-modal>
</template>

<script>
import StarRating from "vue-star-rating";
import { mapGetters } from "vuex";
// import axios from "axios";

export default {
  name: "TrainingRecommendation",
  components: {
    StarRating,
  },
  data() {
    return {
      action: "approve",
      description: "",
      rating: null,
      feedback: "",
      status: "",
      context: "",
      time: "",
      uid: "",
      recommended_training: {},
    };
  },
  methods: {
    closeTrainingModal() {
      document.querySelector("#training-modal").visible = false;
    },
    setAcceptRejRec(params) {
      if (params.e.target.active) {
        this.action = params.val;
      }
    },
    setSelectedRecommendation(index) {
      if (index === undefined) {
        this.action = "approve";
        this.description = "";
        this.rating = null;
        this.feedback = "";
        this.status = "";
        this.summary = "";
        this.time = "";
        this.uid = "";
        this.context = "";
        this.recommended_training = {};
      } else {
        this.action = "approve";
        this.description = this.trainingReccomendations[index].description;
        this.rating = this.trainingReccomendations[index].rating;
        this.feedback = this.trainingReccomendations[index].feedback;
        this.status = this.trainingReccomendations[index].status;
        this.summary = this.trainingReccomendations[index].summary;
        this.time = this.trainingReccomendations[index].time;
        this.uid = this.trainingReccomendations[index].uid;
        this.context = this.trainingReccomendations[index].context;
        this.recommended_training = {
          ...this.trainingReccomendations[index].recommended_training[0],
        };
      }
    },
    setRating($event) {
      this.rating = $event;
    },
    setRecComment($event) {
      if ($event) {
        this.feedback = $event.target.value;
      } else {
        this.feedback = "";
      }
    },
  },
  computed: {
    ...mapGetters([
      "backendURL",
      "getReviewDescription",
      "selectedTrainingRecommandationIndex",
      "trainingReccomendations",
      "getCSEName",
    ]),
  },
  watch: {
    selectedTrainingRecommandationIndex: function (val) {
      this.setSelectedRecommendation(val);
    },
  },
};
</script>

<style scoped>
.training-recommendation {
  /* Add your component styles here */
}
</style>
